import React, { useState, useEffect } from "react";
import { Grid, Container, Typography, makeStyles } from "@material-ui/core";
import Page from "src/components/Page";
import * as actions from "src/actions/auth";
import MyEnrollmentsList from "./MyEnrollmentsList";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    borderRadius: 25,
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
}));

const MyEnrollmentsListView = () => {
  const classes = useStyles();
  const [courses, setCourses] = useState([]);

  useEffect(() => {
    actions
      .getMyEnrollments()
      .then((response) => {
        setCourses(response.data);
      })
      .catch((error) => {
        console.log("Error: ", error);
      });
  }, []);

  return (
    <Page className={classes.root} title="Enrollments">
      <Container maxWidth={false}>
        <Grid>
          <Typography variant="h2">My Enrollments List</Typography>
        </Grid>
        <Grid>
          {courses.map((course, index) => (
            <MyEnrollmentsList course={course} key={index} />
          ))}
        </Grid>
      </Container>
    </Page>
  );
};

export default MyEnrollmentsListView;
